import { DocumentsListCard, type DocumentsListStatus } from './DocumentsListCard';
import { AgreementDocumentsDataTable } from './AgreementDocumentsDataTable';
import type { DocumentsAbilities, DocumentsCallbacks } from './documentsTabView.types';
import type { GeneratedDocumentsPage } from '../../types/agreementDocuments.types';
import { isStillGenerating } from '../../utils/generatedDocumentDisplay';

interface Props extends DocumentsAbilities, DocumentsCallbacks {
    status: DocumentsListStatus;
    page: GeneratedDocumentsPage | undefined;
    currentPage: number;
    now: number;
    onRetry: () => void;
    onRefresh: () => void;
    onPageChange: (page: number) => void;
}

export function AgreementDocumentsTab({ status, page, currentPage, now, canGenerate, canRead, onGenerate, onView, onDownload, onDetails, onRetry, onRefresh, onPageChange }: Props) {
    const documents = page?.data ?? [];

    return (
        <DocumentsListCard
            status={status}
            page={page}
            currentPage={currentPage}
            canGenerate={canGenerate}
            hasStillGenerating={documents.some((document) => isStillGenerating(document, now))}
            onGenerate={onGenerate}
            onRetry={onRetry}
            onRefresh={onRefresh}
            onPageChange={onPageChange}
        >
            <AgreementDocumentsDataTable documents={documents} now={now} canRead={canRead} onView={onView} onDownload={onDownload} onDetails={onDetails} />
        </DocumentsListCard>
    );
}
